var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6975 0.733538C10.7645 0.800503 10.798 0.877511 10.798 0.964565C10.798 1.05162 10.7645 1.12863 10.6975 1.19559L6.01674 5.8764C5.94978 5.94336 5.87277 5.97684 5.78571 5.97684C5.69866 5.97684 5.62165 5.94336 5.55469 5.8764L0.873884 1.19559C0.806919 1.12863 0.773438 1.05162 0.773438 0.964565C0.773438 0.877511 0.806919 0.800503 0.873884 0.733538L1.37612 0.231306C1.44308 0.164341 1.52009 0.130859 1.60714 0.130859C1.6942 0.130859 1.77121 0.164341 1.83817 0.231306L5.78571 4.17885L9.73326 0.231306C9.80022 0.164341 9.87723 0.130859 9.96429 0.130859C10.0513 0.130859 10.1283 0.164341 10.1953 0.231306L10.6975 0.733538Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.40cc23bb957919fe843be8ffae94a7ad.svg";
export { ForwardRef as ReactComponent };